import { BehaviorProfileStatus } from '../../phasrRestrictedProfilesSelector/types';

export interface PhasrBehavioralProfilesComponentSchema {
  id: string,
  companyId: string,
  departments?: GetDepartmentsRecords[],
  collection?: string,
  behavioralProfileType: BehavioralProfileTypes,
}

export enum PhasrBehavioralProfilesMethods {
  GET_DEPARTMENTS = 'getDepartments',
  GET_DEPARTMENT_USERS = 'getDepartmentIdentities',
  GET_USER_DEVICES = 'getUserResources',
}

export interface Filter {
  property: string;
  value: string | number;
}

export interface RequestPayload {
  page: number,
  companyId: string,
  filter: Array<Filter>,
  limit?: number,
}

export interface GetDepartmentsResponse {
  records: GetDepartmentsRecords[],
  totalRecords: number,
}

export interface GetDepartmentsRecords {
  behavioralProfileDepartment: string,
  behavioralProfileDepartmentName: string,
  totalProfiles: number,
  restrictedProfiles: number,
  status: BehaviorProfileStatus
}

export interface GetDepartmentIdentitiesResponse {
  totalRecords: number,
  records: GetDepartmentIdentitiesRecords[]
}

export interface GetDepartmentIdentitiesRecords {
  departmentId: string,
  behavioralProfileIdentity: string,
  behavioralProfileIdentityName: string,
  totalProfiles: number,
  restrictedProfiles: number,
  status: BehaviorProfileStatus
}

export interface GetUserResourcesResponse {
  records: GetUserResourcesRecord[],
  totalRecords: number
}

export interface GetUserResourcesRecord {
  departmentId: string,
  userId: string,
  behavioralProfileResource: string,
  behavioralProfileResourceName: string,
  status: BehaviorProfileStatus
}

export enum BehavioralProfileTypes {
  DIRECT_CONTROL = '0',
  AUTOPILOT = '1',
}

export const LOAD_LIMIT = 20;
